export default "__VITE_ASSET__a1789c22__"